import React from "react";

const AnimatedCard = () => {
    return (
        <div style={{ marginTop: '50px' }}><h1 style={{ textAlign: 'center', }}><span style={{ color: 'rgb(4 133 155)' }}>Intelligent </span> Solutions</h1>
            <div className="cardssContainer">
                <div className="cardssBox">
                    <div className="cardss">
                        <h2>FactoryPro</h2>
                        {/* all the data formated community changes the refreshing the code and related community and */}
                        {/* <span>Hover Me</span> */}
                        {/* remaining data also not founded in the relationalship code and formated things in the digitalengineeringage.js, code, coustomerBanner.js, ContactMap.js, */}
                        <div className="content">
                            <h3 style={{ color: "rgb(8 123 150)" }}>FactoryPro</h3>
                            <p style={{ textAlign: 'center', width: "219px" }}>
                                Digitalize day-in-a-life at Factory floor – Production, Quality, Maintenance, Workflows to improve performance and reduce cost.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="cardssBox">
                    <div className="cardss">
                        <h2>EnergyCare</h2>
                        {/* <span>Hover Me</span> */}
                        <div className="content">
                            <h3 style={{ color: "rgb(8 123 150)" }}>FactoryPro</h3>
                            <p style={{ textAlign: 'center', width: "219px" }}>
                                Digitalize day-in-a-life at Factory floor – Production, Quality, Maintenance, Workflows to improve performance and reduce cost.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="cardssBox">
                    <div className="cardss">
                        <h2>FactoryDtect</h2>
                        {/* <span>Hover Me</span> */}
                        <div className="content">
                            <h3 style={{ color: "rgb(8 123 150)" }}>FactoryPro</h3>

                            <p style={{ textAlign: 'center', width: "219px" }}>
                                Digitalize day-in-a-life at Factory floor – Production, Quality, Maintenance, Workflows to improve performance and reduce cost.
                            </p>
                        </div>
                    </div>
                </div>

                <style>
                    {`
          @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap");

          .cardssContainer {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 45px;
            width: 100%;
            height: 80vh;
            flex-wrap: wrap;
            margin-top: -50px;
          }

          .cardssBox {
            width: 300px;
            height: 400px;
            position: relative;
            display: grid;
            place-items: center;
            overflow: hidden;
            border-radius: 20px;
            box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 10px 0px,
              rgba(0, 0, 0, 0.5) 0px 2px 25px 0px;
          }

          .cardss {
            position: absolute;
            width: 95%;
            height: 95%;
            background: #08829f;
            border-radius: 20px;
            z-index: 5;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            text-align: center;
            color: #ffffff;
            overflow: hidden;
            padding: 20px;
            cursor: pointer;
            box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 60px -12px inset,
              rgba(0, 0, 0, 0.5) 0px 18px 36px -18px inset;
          }

       

          span {
            top: 75%;
          }

          .cardss .content h3 {
            font-size: 25px;
            padding-bottom: 10px;
            text-align: left;
          }

     

          .cardss .content {
            transform: translateY(100%);
            opacity: 0;
            transition: 0.3s ease-in-out;
          }

          .cardss:hover .content {
            transform: translateY(0);
            opacity: 1;
          }

          .cardss:hover h2,
          .cardss:hover span {
            opacity: 0;
          }

          .cardssBox::before {
            content: "";
            position: absolute;
            width: 40%;
            height: 150%;
            background: #40e0d0;
            background: -webkit-linear-gradient(to right, #ff0080, #ff8c00, #40e0d0);
            background: linear-gradient(to right, #edcf39, #ff8c00, #06849e);
            animation: glowing 5s linear infinite;
            transform-origin: center;
          }

          @keyframes glowing {
            0% {
              transform: rotate(0);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
                </style>
            </div>
        </div>
    );
};

export default AnimatedCard;
